import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Defect } from '~/entities/Inspection'
import { Button } from '~/shared/ui/Buttons'
import { ImageSlider } from '~/shared/ui/ImageSlider'
import { IonToolbarFooter, IonToolbarHeader } from '~/shared/ui/PageContainer'
import { Description, Title, WrapperFooter, WrapperHeader } from './styled'

type DefectRepairModalProps = {
  selectedDefect?: Defect
  isShow: boolean
  onCancel: () => void
  onRepairOk: () => void
  onRepairCancel: () => void
  canRepair: boolean
}

export function DefectRepairModal({
  selectedDefect,
  isShow,
  onCancel,
  onRepairOk,
  onRepairCancel,
  canRepair,
}: DefectRepairModalProps) {
  const { t } = useTranslation()

  const images = useMemo(() => {
    return (selectedDefect?.photos || []).map((photo) => ({
      id: photo.uuid,
      src: photo.originalUrlDownload,
    }))
  }, [selectedDefect?.photos])

  if (!selectedDefect) return null

  const handleOnOk = () => {
    selectedDefect?.isRepairDamage ? onRepairCancel() : onRepairOk()
  }

  const okTitle = selectedDefect?.isRepairDamage ? 'cancel repair' : 'repair'

  return (
    <IonModal
      isOpen={isShow}
      keepContentsMounted={false}
      onWillDismiss={onCancel}
    >
      <IonHeader>
        <IonToolbarHeader>
          <WrapperHeader>
            <Title>{selectedDefect?.carDetail?.label}</Title>
            <Description>
              {selectedDefect?.carDamageExtent?.label} {t('damage')}
            </Description>
          </WrapperHeader>
        </IonToolbarHeader>
      </IonHeader>
      <IonContent
        style={{
          '--overscroll-behavior': 'none',
          '--webkit-overscroll-behavior': 'none',
          '--overflow': 'hidden',
        }}
      >
        <ImageSlider images={images} />
      </IonContent>
      <IonFooter>
        <IonToolbarFooter>
          <WrapperFooter
            style={{
              justifyContent: canRepair ? 'space-between' : 'flex-end',
            }}
          >
            {canRepair && (
              <Button uppercase variant='textCrimson' onClick={handleOnOk}>
                {t(okTitle)}
              </Button>
            )}
            <Button uppercase variant='textBlue' onClick={onCancel}>
              {t('button.cancel')}
            </Button>
          </WrapperFooter>
        </IonToolbarFooter>
      </IonFooter>
    </IonModal>
  )
}
